import React from 'react';
import * as s from './styled-input';

// Input com suporte a icone (legado src=URL OR icon=ReactNode novo).
// Caller pode usar:
//   <Input src={icons.SearchIcon} />           // legado <img>
//   <Input icon={<Icon name="search" />} />     // novo Lucide-style
const Input = ({
  src,
  icon,
  placeholder,
  onChange,
  value,
  style,
  width,
  height,
  type,
  size,
  noPadding,
  focused,
  onClick,
  login,
  disabled,
  maxLength,
}) => {
  return (
    <s.Container
      disabled={disabled}
      focused={focused}
      width={width}
      height={height}
      style={style}
      noPadding={noPadding}
      title={placeholder}
      login={login}
    >
      {icon ? (
        <s.IconWrapper>{icon}</s.IconWrapper>
      ) : (
        src && <s.Icon src={src} alt="icon" size={size} />
      )}
      <s.Input
        maxLength={maxLength}
        width={width}
        height={height}
        onClick={onClick}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        type={type || 'text'}
        login={login}
      />
    </s.Container>
  );
};

export default Input;
